import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { SolicitudesCreditoController } from './solicitudes-credito.controller';
import { SolicitudesCreditoService } from './solicitudes-credito.service';

@Module({
  imports: [PrismaModule],
  controllers: [SolicitudesCreditoController],
  providers: [SolicitudesCreditoService],
  exports: [SolicitudesCreditoService],
})
export class SolicitudesCreditoModule {}
